import request from '@/utils/request'

import { tokenurl, f10url, getwayurl, searchurl,auth } from './config'

type dataType = any
export default {
  getToken(): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  fdzqdevToken(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  fdzqProToken(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  sylappDevToken(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  sylappProToken(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 搜索个股
  searchStock(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: searchurl + '/v2/search',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  }
}
